import React from "react";
import { Helmet } from "react-helmet-async";

const DEFAULTS = {
  siteName: "CIRCODU Uganda",
  baseUrl: "https://circodu.org.ug",
  image: "https://circodu.org.ug/default-og-image.jpg",
  twitterHandle: "@CIRCODU1",
};

// Safety net: strips www if it ever sneaks into a URL
const toCanonical = (url) => url?.replace(/^(https?:\/\/)www\./, "$1") ?? url;

const SEO = ({
  title,
  description,
  keywords,
  url,
  image,
  datePublished,
  dateModified,
  type = "article",
}) => {
  const fullTitle = `${title} | ${DEFAULTS.siteName}`;
  const finalUrl = toCanonical(
    url ? `${DEFAULTS.baseUrl}${url}` : DEFAULTS.baseUrl,
  );
  const finalImage = toCanonical(
    image
      ? image.startsWith("http")
        ? image
        : `${DEFAULTS.baseUrl}${image}`
      : DEFAULTS.image,
  );

  const structuredData = JSON.stringify({
    "@context": "https://schema.org",
    "@type": "Article",
    headline: title,
    datePublished: datePublished || null,
    dateModified: dateModified || datePublished || null,
    author: { "@type": "Organization", name: "CIRCODU" },
    publisher: {
      "@type": "Organization",
      name: "CIRCODU",
      url: DEFAULTS.baseUrl,
      logo: { "@type": "ImageObject", url: "https://circodu.org.ug/logo.png" },
    },
    description,
    url: finalUrl,
    image: finalImage,
  });

  return (
    <Helmet>
      {/* ── Basic ───────────────────────────────────── */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={finalUrl} />

      {/* ── Open Graph ──────────────────────────────── */}
      <meta property="og:site_name" content={DEFAULTS.siteName} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={finalUrl} />
      <meta property="og:image" content={finalImage} />

      {/* ── Twitter / X ─────────────────────────────── */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content={DEFAULTS.twitterHandle} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={finalImage} />

      {/* ── Structured Data ─────────────────────────── */}
      <script type="application/ld+json">{structuredData}</script>
    </Helmet>
  );
};

export default SEO;
